import { Loader2, AlertTriangle } from "lucide-react";

export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-8 rise">
    <div>
      <div className="label mb-3">{eyebrow}</div>
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
      {desc && <p className="text-sm md:text-base text-[#5C5C58] mt-3 max-w-2xl">{desc}</p>}
    </div>
    <div className="flex gap-2 flex-wrap">{children}</div>
  </div>
);

export const Panel = ({ title, sub, children, className = "", testid, action }) => (
  <section data-testid={testid} className={`bg-[#FFFFFF] border border-[#E8E8E4] p-6 rise ${className}`}>
    {(title || action) && (
      <div className="flex items-start justify-between mb-5 gap-3">
        <div>
          <h3 className="font-display text-lg font-semibold">{title}</h3>
          {sub && <p className="text-xs text-[#5C5C58] mt-1">{sub}</p>}
        </div>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Kpi = ({ label, value, hint, accent, testid }) => (
  <div data-testid={testid} className="bg-[#FFFFFF] border border-[#E8E8E4] p-5 hover:-translate-y-0.5 hover:border-[#BDBDB5] transition-transform rise">
    <div className="label">{label}</div>
    <div className={`font-mono-num text-3xl font-medium mt-3 ${accent ? "text-[#C05C3D]" : "text-[#1C1C1A]"}`}>{value}</div>
    {hint && <div className="text-xs text-[#5C5C58] mt-2">{hint}</div>}
  </div>
);

export const Loading = () => (
  <div data-testid="loading" className="flex items-center gap-2 text-sm text-[#5C5C58] py-20"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento dati...</div>
);

export const ErrorBox = ({ msg }) => (
  <div data-testid="error-box" className="border border-[#C05C3D] bg-[#FBF1ED] text-[#8C3A22] p-4 text-sm flex gap-2"><AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />{msg}</div>
);

export const Warnings = ({ list }) => list?.length ? (
  <details data-testid="warnings" className="border border-[#E8E8E4] bg-[#FFFBF0] p-3 text-xs text-[#6B5A1E] mb-6">
    <summary className="cursor-pointer font-semibold">{list.length} metriche non disponibili da Meta</summary>
    <ul className="mt-2 space-y-1 list-disc pl-5">{list.map((w, i) => <li key={i}>{w}</li>)}</ul>
  </details>
) : null;

export const Bar = ({ value, max, color = "#2A4B3C" }) => (
  <div className="h-1.5 bg-[#F1F1EC] w-full"><div className="h-full" style={{ width: `${max ? Math.min(100, (value / max) * 100) : 0}%`, background: color }} /></div>
);
